<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-card :loading="salvando">
      <v-card-title class="headline">Criar Atualização</v-card-title>
      <v-card-text>
        <v-form ref="formDialog" v-model="validForm" @submit.prevent>
          <v-container>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="atualizacao.empresa.id"
                  :items="itens.empresa"
                  :rules="[obrigatorio]"
                  label="Empresa"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="atualizacao.observacao"
                  label="Observação"
                  required
                  :rules="[obrigatorio]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-menu
                  v-model="menuDataInicio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :rules="[obrigatorio]"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataInicioFormatada"
                      v-mask="['##/##/####']"
                      label="Inicio"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      :rules="[obrigatorio]"
                      v-on="on"
                      @blur="dataInicio = parseDate(dataInicioFormatada)"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dataInicio" @input="menuDataInicio = false" />
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuDataFim"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataFimFormatada"
                      v-mask="['##/##/####']"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      :rules="[obrigatorio]"
                      v-on="on"
                      @blur="dataFim = parseDate(dataFimFormatada)"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dataFim" @input="menuDataFim = false" />
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="atualizacao.tipoLeitor"
                  :items="['SPED_PIS_COFINS', 'SPED_ICMS']"
                  label="Leitor de Arquivos"
                  :rules="[obrigatorio]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-alert v-if="showMessageError" dense outlined type="error">
                  {{ dataError }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="green darken-1" text :disabled="!validForm" @click="salvar(atualizacao)"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Atualizacao from '@/models/atualizacao'
import AtualizacaoService from '@/services/atualizacao/atualizacao'
import { obrigatorio } from '@/shareds/regrasForm'
import { formatDate, parseDate } from '@/shareds/formatacoes'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },

  props: ['showDialog', 'itens'],

  data: () => ({
    dialog: false,
    atualizacao: new Atualizacao(),
    obrigatorio: obrigatorio,
    formatDate: formatDate,
    parseDate: parseDate,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false,
    dataInicio: '',
    dataFim: '',
    dataInicioFormatada: '',
    dataFimFormatada: ''
  }),

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },
    dataInicio() {
      this.dataInicioFormatada = this.formatDate(this.dataInicio)
    },
    dataFim() {
      this.dataFimFormatada = this.formatDate(this.dataFim)
    }
  },

  methods: {
    async salvar(atualizacao) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          empresa: atualizacao.empresa,
          observacao: atualizacao.observacao,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          tipoLeitor: atualizacao.tipoLeitor
        }

        const atualizacaoSalva = await AtualizacaoService.create(data)

        this.$emit('confirmado', atualizacaoSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$refs.formDialog.reset()
      this.$emit('update:showDialog', false)
    },

    selectFile(file) {
      if (!file) return
    }
  }
}
</script>
